import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import { formatMoney } from 'common/helpers';
import Button from 'components/Button';
import { getPercentage } from './../helpers';
import { Hotel as S } from './../styles';

class Rooms extends React.Component {
  renderRoom = (room, index) => {
    const { roomImages, deeplink, hotelName } = this.props;
    const disabled = room.quantities_remaining <= 0;
    const origPrice = room.strike_through_price;
    return (
      <S.RoomMobile key={room.name}>
        <div>
          <div className="image" style={{ backgroundImage: `url(${roomImages[index]})` }} />
          <div className="info">
            <label>{getPercentage(origPrice, room.price)}% off</label>
            <p className="warning">{room.quantities_remaining > 0 ? 'Running Low!' : 'SOLD OUT!'}</p>
            <h4>{room.name}</h4>
            <p className="price">THB {formatMoney(room.notes, 0)} (~${formatMoney(room.price, 0)}+)<span className="asterisk">*</span> <strike>~${formatMoney(room.strike_through_price, 0)}</strike></p>
          </div>
        </div>
        <a href={deeplink} target="blank">
          <Button size="1.6em" padding="5px 15px" disabled={disabled} style={{ width: '100%', boxShadow: 'none' }} data-hotel-name={`${hotelName} - ${room.name}`}>{room.quantities_remaining > 0 ? 'Reserve now' : 'SOLD OUT'}</Button>
        </a>
      </S.RoomMobile>
    );
  }
  render() {
    const { rooms } = this.props;
    const sortedRooms = orderBy(rooms, ['id'], ['asc']);
    return (
      <S.RoomsMobile>
        { sortedRooms.map((room, index) => (
          this.renderRoom(room, index)
        )) }
      </S.RoomsMobile>
    );
  }
}

Rooms.propTypes = {
  rooms: PropTypes.array.isRequired,
  roomImages: PropTypes.array.isRequired,
  deeplink: PropTypes.string.isRequired,
  hotelName: PropTypes.string.isRequired,
};

export default Rooms;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/RoomsMobile.js